/**
 * Reglas de visibilidad de entradas del menú según el rol del usuario.
 * Las comparten SimpleSidenav (sidebar) y BuscadorGlobal (Ctrl+K).
 */
import { tienePermisosModulo } from "lib/seguridad/permisosPorModulo";

export function esClavePublica(moduleKey) {
  return moduleKey === undefined || moduleKey === null || String(moduleKey).trim() === "";
}

/**
 * Una entrada puede declarar varios programas en `keys` (pantallas
 * unificadas): es visible si el usuario tiene acceso a cualquiera.
 * `programa` permite que una entrada comparta permiso con otra (misma
 * fila de rolesusuarios) manteniendo su `key` único para React/App.
 */
export function tieneAccesoEntrada(route, roleDetalles) {
  const moduleKeys =
    Array.isArray(route?.keys) && route.keys.length ? route.keys : [route?.programa ?? route?.key];
  return moduleKeys.some(
    (moduleKey) => esClavePublica(moduleKey) || tienePermisosModulo(roleDetalles, moduleKey)
  );
}
